import { useTranslation } from "react-i18next";
import SectionHeader from "../Common/SectionHeader";

const GiftsHeader = ({ totalValue }) => {
    const { t } = useTranslation();

    return (
        <SectionHeader
            title={t("MY_GIFTS_TITLE")}
            subtitle={t("MY_GIFTS_SUBTITLE")}
            rightSlot={(
                <div className="w-fit rounded-full bg-[#eef2ff] px-4 py-2 text-xs font-semibold text-primary">
                    {t("MY_GIFTS_TOTAL_VALUE")}: {totalValue}
                </div>
            )}
        />
    );
};

export default GiftsHeader;
